<template>
    <img :src="src" />
</template>

<script>
export default {
	name: "Image",
	props: {
		src: {
			type: String,
			default: "/img/question_image.png"
		}
	}
};
</script>

<style scoped lang="scss">
img {
    --border-radius: 0px;
    --border: 0 solid #000000;

    @media (min-width: 1024px) {
        --border-radius: 20px;
        --border: 4px solid #000000;
    }

    border-radius: var(--border-radius);
    border: var(--border);
    width: 100%;
}
</style>

